import NonstaticFooter from './NonstaticFooter';
export default NonstaticFooter;